import { z } from 'zod';

export const GeneralConfigValidator = z.object({
  newSchoolNotificationReceiverEmail: z.string().email(),
});

export type GeneralConfig = z.infer<typeof GeneralConfigValidator>;
